export async function GetAuthToken() {
  // Use global firebase (client side) and get the id token of the current user.
  if (globalThis.firebase)
    return {
      token: await globalThis.firebase.auth().currentUser?.getIdToken(),
      type: 'id_token'
    };
  // Otherwise, use the admin SDK to get the access token of the
  else if (typeof require == 'function')
    return {
      token: await require('firebase-admin')
        .credential.applicationDefault()
        .getAccessToken()
        .then((x) => x.access_token),
      type: 'access_token'
    };
}
